var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 11,
    viewBox: "0 0 22 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M20.97 5.52473C20.97 5.52473 18.6394 6.54513 17.4087 7.42014C16.178 8.29516 14.7305 9.96094 14.7305 9.96094",
    stroke: "white",
    strokeWidth: 1.40374
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M20.9702 5.51769C20.9702 5.51769 18.6532 4.46681 17.434 3.57572C16.2148 2.68463 14.7891 1 14.7891 1",
    stroke: "white",
    strokeWidth: 1.40374
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 3",
    d: "M0 5.49756L16 5.51562",
    stroke: "white",
    strokeWidth: 1.32116
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterArrow);
export default __webpack_public_path__ + "static/media/footer-arrow.02ae8570962628b8c2d9b43d9dfc0758.svg";
export { ForwardRef as ReactComponent };